import { VehicleSelectionMethod } from '../../enums';
export const getSelectedEntryMapping = (state, action) => {
    if (action.payload.vin === '' && action.payload.vehicleSelectionMethod == VehicleSelectionMethod.VinDecode) {
        return new Map();
    }
    return state;
};
//# sourceMappingURL=getSelectedEntryMapping.js.map